import React from 'react';
import { BaseLabel } from "./base-label.component";
export class BaseSlider extends React.Component {
  constructor(props) {
    super(props);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.node = null;
  }
  componentWillUnmount() {
    this.removeDocumentMouseMoveListener();
    this.removeDocumentMouseUpListener();
    this.removeDocumentTouchEndListener();
    this.removeDocumentTouchMoveListener();
  }
  getStyle() {
    const perc = (this.props.percentage || 0) * 100;
    const style = {
      position: 'absolute',
      left: `${perc}%`
    };
    return style;
  }

  /**
   * Listen to mousemove event
   */
  addDocumentMouseMoveListener() {
    this.removeDocumentMouseMoveListener();
    if (this.node) this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
  }

  /**
   * Listen to mouseup event
   */
  addDocumentMouseUpListener() {
    this.removeDocumentMouseUpListener();
    if (this.node) this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
  }

  /**
   * Listen to touchmove event
   */
  addDocumentTouchMoveListener() {
    this.removeDocumentTouchMoveListener();
    if (this.node) this.node.ownerDocument.addEventListener('touchmove', this.handleTouchMove);
  }

  /**
   * Listen to touchend event
   */
  addDocumentTouchEndListener() {
    this.removeDocumentTouchEndListener();
    if (this.node) this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
  }
  removeDocumentMouseMoveListener() {
    if (this.node) this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
  }
  removeDocumentMouseUpListener() {
    if (this.node) this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
  }
  removeDocumentTouchMoveListener() {
    if (this.node) this.node.ownerDocument.removeEventListener('touchmove', this.handleTouchMove);
  }
  removeDocumentTouchEndListener() {
    if (this.node) this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
  }
  handleMouseDown() {
    this.addDocumentMouseMoveListener();
    this.addDocumentMouseUpListener();
  }
  handleMouseUp() {
    this.removeDocumentMouseMoveListener();
    this.removeDocumentMouseUpListener();
  }
  handleMouseMove(event) {
    this.props.onSliderDrag(event, this.props.type);
  }
  handleTouchStart() {
    this.addDocumentTouchEndListener();
    this.addDocumentTouchMoveListener();
  }
  handleTouchMove(event) {
    this.props.onSliderDrag(event, this.props.type);
  }
  handleTouchEnd() {
    this.removeDocumentTouchMoveListener();
    this.removeDocumentTouchEndListener();
  }
  handleKeyDown(event) {
    this.props.onSliderKeyDown(event, this.props.type);
  }
  render() {
    const style = this.getStyle();
    return /*#__PURE__*/React.createElement("span", {
      className: this.props.classNames.sliderContainer,
      ref: node => {
        this.node = node;
      },
      style: style
    }, /*#__PURE__*/React.createElement(BaseLabel, {
      classNames: this.props.classNames,
      formatLabel: this.props.formatLabel,
      type: "value"
    }, this.props.value), /*#__PURE__*/React.createElement("div", {
      "aria-labelledby": this.props.ariaLabelledby,
      "aria-controls": this.props.ariaControls,
      "aria-valuemax": this.props.maxValue,
      "aria-valuemin": this.props.minValue,
      "aria-valuenow": this.props.value,
      className: this.props.classNames.slider,
      draggable: "false",
      onKeyDown: this.handleKeyDown,
      onMouseDown: this.handleMouseDown,
      onTouchStart: this.handleTouchStart,
      role: "slider",
      tabIndex: 0
    }));
  }
}